<script>
	export let title;
	export let description;

	const siteTitle = 'Bloom Network Social Movement';
	const siteImage = 'https://bloomnetwork.earth/img/bloomLanding.png';
	const formattedTitle = title ? `${title} | ${siteTitle}` : siteTitle;
</script>

<svelte:head>
	<title>{formattedTitle}</title>

	<!-- THIS WAS ORIGINAL INFO HERE. TODO: SEE IF ADDITIONAL DATA HERE ADDRESSES SEO OR IS STILL INCORRECT -->
	<!-- <meta property="og:site_name" content={siteTitle} />
	<meta property="og:title" content={title} />
	<meta property="og:description" content={description} /> -->

	<meta property="og:site_name" content={siteTitle} />
	<meta property="og:title" content={title} />
	<meta property="og:description" content={description} />
	<meta property="og:type" content="website" />
	<meta property="og:image" content={siteImage} />
	<meta property="twitter:card" content="summary_large_image" />
	<meta property="twitter:title" content="Bloom Network" />
	<meta property="twitter:description" content={description} />
	<meta property="twitter:image" content={siteImage} />
</svelte:head>
